export default {
    "name": "CreateGroup",
    "kind": "HoudiniMutation",
    "hash": "8633d34236ac74346d31ab4bda4a5de0ceac58af79493683cd4acbc92610cf58",

    "raw": `mutation CreateGroup($input: NewGroup!) {
  createGroup(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createGroup": {
                "type": "Group",
                "keyRaw": "createGroup(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "NewGroup"
        },

        "types": {
            "NewGroupPermission": {
                "level": "PermissionLevel",
                "permissionId": "UInt"
            },

            "NewGroup": {
                "name": "String",
                "permissions": "NewGroupPermission",
                "userAccounts": "UInt"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=5753747edff71efd35af03b6426dda80a8d77625a49ad2aec4125ee246319537";